import { useContext } from '@nuxtjs/composition-api'

/**
 * This is a temporary solution, as Nuxt/Vue 2 does not support top level
 * async/await, which prevents desired (re)usage of useFetch
 */
// TODO: migrate this composable to useFetch when possible
export const useApiFetch = async (
  endpoint,
  method = 'get',
  options = {},
  { $config } = useContext(),
) => {
  const baseURL = $config.apiBaseUrl

  const response = await fetch(`${baseURL}${endpoint}`, {
    ...options,
    method,
  }).catch((error) => Promise.reject(error))

  return response.json()
}
